// src/components/common/FadeInSection.jsx
import React, { useState, useEffect, useRef } from 'react';

const FadeInSection = ({ children, delay = '0s' }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      });
    });
    
    const currentElement = domRef.current;
    if (currentElement) observer.observe(currentElement);
    
    return () => {
      if (currentElement) observer.unobserve(currentElement);
    };
  }, []);

  return (
    <>
      <style>{`
        .fade-in-section {
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          will-change: opacity, visibility;
        }
        
        .fade-in-section.is-visible {
          opacity: 1;
          transform: none;
        }
      `}</style>
      
      <div
        ref={domRef}
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        style={{ transitionDelay: delay }}
      >
        {children}
      </div>
    </>
  );
};

export default FadeInSection;